"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.167 4l-.334 1h2.334c.55 0 .884.327.734.727L8.432 18.273c-.15.4-.715.727-1.265.727H4.833L4.5 20h9.667l.333-1h-2.667c-.55 0-.884-.326-.734-.727l4.469-12.546c.15-.4.715-.727 1.265-.727h2.334l.333-1h-9.333z" }), "Italic");
//# sourceMappingURL=Italic.js.map